import { Component, inject, OnInit, CUSTOM_ELEMENTS_SCHEMA, Inject, OnDestroy } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CwcInputValueAccessorDirective } from '../shared/directives/cwc-input-value-accessor.directive';
//import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { TokenService } from '../../services/token.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { TranslationService } from '../../services/translation.service';
import {
  MsalService,
  MsalModule,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { AuthenticationResult, PopupRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { UserService } from '../../services/user.service';
import { AppConfigService } from '../../config/app-config.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CwcInputValueAccessorDirective,
    TranslatePipe,
    CommonModule,
    MsalModule,
    RouterOutlet,
    RouterLink],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent implements OnInit, OnDestroy {

  private userService = inject(UserService);
  private translationService = inject(TranslationService);
  private router = inject(Router);
  private tokenService = inject(TokenService);
  private fb = inject(FormBuilder);
  private appConfig = inject(AppConfigService);
  activeLang: string = 'es';
  loading: boolean = false;
  loginError: string | null = null;
  loginForm!: FormGroup;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) { }

  ngOnInit() {
    this.authService.handleRedirectObservable().subscribe();
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  changeLanguage(lang: string) {
    // console.log('Cambiando idioma a:', lang);
    this.activeLang = lang;
    this.translationService.setLanguage(lang);
  }



  loginPopup() {
    let request: PopupRequest = {
      scopes: [
        'user.read',
        this.appConfig.value.scope
      ]
    };

    this.authService.loginPopup(request)
      .subscribe((response: AuthenticationResult) => {
        this.authService.instance.setActiveAccount(response.account);
      });
  }


  onSubmit() {
    this.loginError = null;
    this.loading = true;

    this.authService.loginPopup({
      scopes: ['user.read', this.appConfig.value.scope]
    }).subscribe({
      next: (response: AuthenticationResult) => {
        this.authService.instance.setActiveAccount(response.account);
        this.tokenService.setToken(response.accessToken);

        this.userService.getSecureUserData().subscribe({
          next: (userData) => {
            const userId = userData?.id?.toString()?.trim() ?? '';

            sessionStorage.setItem('UserID', userId);
            sessionStorage.setItem('userTypeId', userData?.userTypeId?.toString() ?? '');
            sessionStorage.setItem('SignMoney', userData?.signo_moneda?.toString() ?? '');
            sessionStorage.setItem('countryId', userData?.countryId?.toString() ?? '');
            sessionStorage.setItem('userData', JSON.stringify(userData));

            if (!userId) {
              this.loginError = 'No se encontró un usuario válido para la sesión.';
              this.loading = false;
              this.router.navigate(['/login']);
              return;
            }

            this.router.navigate(['/admin']);
          },
          error: (err) => {
            console.error('Error al obtener datos del usuario:', err);
            this.loginError = 'No se pudo obtener datos del usuario';
            this.loading = false;
          }
        });
      },
      error: (err) => {
        console.error('Error en login:', err);
        this.loginError = 'No se pudo iniciar sesión';
        this.loading = false;
      }
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.authService.logoutRedirect();
    }
  }
}
